import { UbicacionDTO } from "@/application/dto/ubicaciones/UbicacionDTO";
import { IUbicacionRepository } from "@/domain/repositories/IUbicacionRepository";

// application/use-cases/CreateUbicacionUseCase.ts

export class PostUbicacionUseCase {

    constructor(
        private repository: IUbicacionRepository
    ) {}

    async execute(data: UbicacionDTO) {
        
        return this.repository.create(data);
    }

}